<template>
	<div class="m-portlet m-portlet--mobile m-portlet-bet-report">
		<div class="m-portlet__head row">
			<div class="col-12 filter">
				<div class="row">
					<div class="col-xl-6 col-lg-12 col-md-12 date">
						<div class="row">
							<div class="col-2">
								<div class="input-group">
									<select class="form-control" v-model="game_selected">
										<option value="-1">Miền</option>
										<option v-for="(game, id) in gameInfo.games" v-bind:value="id">
											{{game}}
										</option>
									</select>
								</div>
							</div>
							<div class="col-2">
								<div class="input-group">
									<select class="form-control" v-model="channel_selected">
										<option value="-1">Đài</option>
										<option v-for="channel in channel_list" v-bind:value="channel.id">
											{{channel.text}}
										</option>
									</select>
								</div>
							</div>
							<div class="col-2">
								<div class="input-group">
									<select class="form-control" v-model="prop_selected">
										<option value="-1">Kiểu</option>
										<option v-for="id in prop_list" v-bind:value="id">
											{{gameInfo.props[id]}}
										</option>
									</select>
								</div>
							</div>
							<div class="col-5">
								<div class="input-daterange input-group" id="date_picker">
									<input type="text" class="form-control m-input" name="start" />
									<div class="input-group-append">
										<span class="input-group-text"><i class="la la-ellipsis-h"></i></span>
									</div>
									<input type="text" class="form-control" name="end" />
								</div>
							</div>
							<div class="col-1">
								<button type="reset" class="btn btn-primary" v-on:click="fetchData()">Lọc</button>
							</div>
						</div>
					</div>
					<div class="col-xl-6 col-lg-12 col-md-12 type">
						<div class="pull-right">
							<div>
								<button type="button" class="btn btn-primary" v-on:click="rangesDate('today')">Hôm nay</button>
								<button type="button" class="btn btn-primary" v-on:click="rangesDate('yesterday')">Hôm qua</button>
								<button type="button" class="btn btn-primary" v-on:click="rangesDate('this_week')">Tuần này</button>
								<button type="button" class="btn btn-primary" v-on:click="rangesDate('last_week')">Tuần trước</button>
								<button type="button" class="btn btn-primary" v-on:click="rangesDate('this_term')">Kỳ này</button>
								<button type="button" class="btn btn-primary" v-on:click="rangesDate('last_term')">Kỳ trước</button>
								<!-- <input type='text' class="form-control date_range_picker" id="daterangepicker_report_bet" readonly placeholder="Chọn ngày" /> -->
							</div>
						</div>
					</div>
				</div>
				<div class="m-separator m-separator--dashed"></div>
			</div>
			<div class="col-12 breadcrumbs">
				<ul class="m-nav m-nav--inline">
                    <li class="m-nav__item" v-for="breadcrumb in levelsActive" v-on:click="onLevelChange(breadcrumb)">
                        <a class="m-nav__link">
                            <span>{{breadcrumb}}</span>
                            <span class="m-nav__separator">/</span>
                        </a>
                    </li>
                    <li class="m-nav__item">
                        <a class="m-nav__link deactive">
                            <span>{{levelsDeactive}}</span>
                        </a>
                    </li>
				</ul>
			</div>
		</div>
		<div class="m-portlet__body">
			<router-view 
				:data="reportData"
			/>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	import { Utilities } from "../../utilities";
	import { mapGetters } from 'vuex';

	const propsInfo = {
		1: [1,2,4,6,7,9,11,12,14,15,16],
		2: [1,2,3,5,6,7,8,10,11,13,14,15,16],
		3: [17,18,19],
		4: [1,2,3,5,6,7,8,10,11,13,14,15,16],
	};

	export default {
		data() {
			return {
				"from": moment(),
				"to": moment(),
				"levelsActive": [],
				"levelsDeactive": "",
				"level": "",
				"game_selected" : -1,
				"channel_selected" : -1,
				"prop_selected" : -1,
				"channel_list" : [],
				"prop_list" : [],
				"channels_by_game" : [],
				"reportData" : []
			}
		},
		created() {
			let router = {name: 'BetReportTotal', params: { code: "admin" } };
			router["params"] = (this.user.role == "admin" || this.user.code == "") ? { code: "admin" } : { code: this.user.code };

			this.$router.replace(router);
		},
	    mounted () {
    		this.groupChannelByGame();
	        this.initDateRangePicker();
	        moment.locale('vi');
	    },
	    beforeRouteUpdate(to, from, next){
	    	if((from.name == "BetReportTotal" && to.name == "BetReportDetail") || from.name == "BetReportDetail" && to.name == "BetReportTotal"){
	    		let tables = $.fn.dataTable.tables();
	    		tables.forEach((e) => {
	    			$(e).DataTable().destroy();
	    		});
	    	}

	    	if(!to.params.smsId){
		    	this.level = to.params.code;
		    	this.fetchData();
	    	}else{
		    	this.level = to.params.code;
		    	this.fetchData(to.params.smsId);
	    	}
		    next();
	    },
		watch:{
	    	game_selected: function(s){
	    		// this._generateAll(this.game_selected);
	    		this.channel_selected = -1;
	    		this.prop_selected = -1;
	    		if(s == -1){
	    			this.channel_list = [];
	    			this.prop_list = [];
	    		}else{
		    		this._generateAll(s);
		    		this.prop_list = propsInfo[s];
	    		}
	    	},
		},
		computed: {
			...mapGetters({
				user: 'user',
		  		gameInfo: 'gameInfo'
			})
		},
		methods: {
			initDateRangePicker: function(){
				let vm = this;
				
				$("#date_picker").datepicker({
				    todayHighlight: true,
				    autoclose: true,
				    format: 'dd-mm-yyyy',
				    endDate: moment().format("DD-MM-YYYY")
				}).on('changeDate', function(e) {
		            vm.from = moment($("input[name='start']").val(), "DD-MM-YYYY");
		            vm.to = moment($("input[name='end']").val(), "DD-MM-YYYY");
				});


				$("input[name='start']").val(moment().format("DD-MM-YYYY"));
				$("input[name='end']").val(moment().format("DD-MM-YYYY"));

	   //   		$("#daterangepicker_report_bet").daterangepicker({
	   //  			opens: "left",
				// 	startDate: moment(),
				// 	endDate: moment(),
				// 	locale: {
				//     	format: 'YYYY-MM-DD'
				//     }
	   //          });
	   //          $('#daterangepicker_report_bet').on('apply.daterangepicker', function(ev, picker) {
	   //          	vm.onDateRangeChange(picker.startDate, picker.endDate);
				// });
			},
			rangesDate: function(type){
				var flag = "2016-06-20";
				var diff = moment().diff(moment(flag, "YYYY-MM-DD"), 'days');
				var thisTermFrom = moment(flag, "YYYY-MM-DD").add(28*Math.floor(diff/28), 'day');
				var lastTermFrom = moment(flag, "YYYY-MM-DD").add((28*(Math.floor(diff/28)-1)), 'day');
				var lastTermTo = moment(flag, "YYYY-MM-DD").add((28*(Math.floor(diff/28)-1)+27), 'day');

				switch(type) {
  					case "today":
  						this.onDateRangeChange(moment(), moment());
				    	break;
				  	case "yesterday":
  						this.onDateRangeChange(moment().subtract(1, 'days'), moment().subtract(1, 'days'));
				    	break;
				  	case "this_week":
  						this.onDateRangeChange(moment().startOf('isoWeek'), moment());
				    	break;
				  	case "last_week":
  						this.onDateRangeChange(moment().startOf('isoWeek').subtract(1,"weeks"), moment().startOf('isoWeek').subtract(1, 'days'));
				    	break;
				  	case "this_term":
  						this.onDateRangeChange(thisTermFrom, moment());
				    	break;
				  	case "last_term":
  						this.onDateRangeChange(lastTermFrom, lastTermTo);
				    	break;
				  	default:
  						this.onDateRangeChange(moment(), moment());

				}
			},
			onDateRangeChange: function(start, end){//param moment
	            this.from = start;
	            this.to = end;

				// $('#daterangepicker_report_bet').data('daterangepicker').setStartDate(start);
				// $('#daterangepicker_report_bet').data('daterangepicker').setEndDate(end);
				$("input[name='start']").val(start.format("DD-MM-YYYY"));
				$("input[name='end']").val(end.format("DD-MM-YYYY"));
	            this.fetchData();
	        },
	        onLevelChange: function(level){
	        	this.level = level;

				let router = {name: 'BetReportTotal', params: { code: level } };
				this.$router.push(router);
	        	// this.fetchData();
	        },

			fetchData: async function(smsId = null){
				if(!this.level) return;

				let res = smsId ? 
							await axios.get("admin-panel/report/winloss/"+this.level+"/"+smsId+"?game="+this.game_selected+"&channel="+this.channel_selected+"&prop="+this.prop_selected+"&from="+this.from.format("YYYY-MM-DD")+"&to="+this.to.format("YYYY-MM-DD")) :
				 			await axios.get("admin-panel/report/winloss/"+this.level+"?game="+this.game_selected+"&channel="+this.channel_selected+"&prop="+this.prop_selected+"&from="+this.from.format("YYYY-MM-DD")+"&to="+this.to.format("YYYY-MM-DD"));
				res = res.data;

				if(res.code == 0){

					this.reportData = res.data.report;

					var breadcrumbs = res.data.breadcrumb;
					var levelsActive = [];
					for(let i in breadcrumbs){
						var b = breadcrumbs[i];
						if((parseInt(i)+1) == breadcrumbs.length){
							this.levelsDeactive = b;
						}else{
							levelsActive.push(b);
						}
					}
					this.levelsActive = levelsActive;
				}
			},
			// buildBreadcrumbs : function(){
			// 	var html = "";
			// 	for(let i in levels){
			// 		var classAction = "breadcrumb";
			// 		if((i+1) == levels.length && ){
			// 			classAction = "";
			// 		}
			// 		html += "<li class='m-nav__item'>"+
			// 				    "<a class='m-nav__link "+classAction+"'>"+
			// 				        "<span></span>"+
			// 				        "<span class='m-nav__separator'>/</span>"+
			// 				    "</a>"+
			// 				"</li>";

			// 	}
			// },
	        groupChannelByGame: function() {
	        	let channels  = {};
	        	for(let i in this.gameInfo.channels){
	        		let channel = this.gameInfo.channels[i];

	        		if(!channels[channel.game_id]) channels[channel.game_id] = [];
	        		channels[channel.game_id].push(channel);
	        	}

	        	this.channels_by_game = channels;
	        },
	        _generateAll: function(game){
	        	let vm = this;
	        	let data = [];

				if(game == 3){
        			data = vm.gameInfo.xienChannels.map((e) => {
        				return {
        					"id": e,
        					"text": e.split(".").map((el) => { return vm.gameInfo.channels[el].alias; }).join(" - ")
        				}
        			});
        		}else{
        			data = vm.channels_by_game[game].map((e) => { return { "id": e.id, "text": e.alias } });

		        	if(game == 1){
		        		vm.channel_selected = 36;
		        	}
        		}
        		vm.channel_list = data;
	        },
		}
	}
</script>

<style>
	.m-portlet.m-portlet-bet-report .btn{
		font-family: "Roboto";
		margin-right: 5px;
	}
	.m-portlet.m-portlet-bet-report .m-portlet__head{
		height: auto;
		border-bottom: 1px solid #ebedf2;
	}
	/*.m-portlet.m-portlet-bet-report .m-portlet__body {
	    padding: 2.2rem 0 0 0;
	}*/
	.m-portlet-bet-report .filter{
		margin: 15px 0 0 0px;
		width: 100%;
	}
	.m-portlet-bet-report .filter .form-control{
		padding: 10px;
	}
	.m-portlet-bet-report .filter .input-group-text,
	.m-portlet-bet-report .filter .btn{
		padding: 10px;
	}
	.m-portlet-bet-report .filter .type,
	.m-portlet-bet-report .filter .date{
		margin-top: 5px;
	}
	.m-portlet-bet-report .filter .date_range_picker{
		text-align: center;
		width: auto;
    	float: left;
    	margin-right: 5px;
	}
	.m-portlet-bet-report .m-separator{
		margin: 0px;
	}
	.m-portlet-bet-report .breadcrumbs .m-nav.m-nav--inline>.m-nav__item{
		padding: 0px;
	}
	.m-portlet-bet-report .breadcrumbs .m-nav__separator,
	.m-portlet-bet-report .breadcrumbs span{
		color: #5867dd;
	    font-size: 18px;
	    font-weight: bold;
	    cursor: pointer;
	}
	.m-portlet-bet-report .breadcrumbs .m-nav__separator{
		padding: 0 4px;
		cursor: default;
	}
	.m-portlet-bet-report .breadcrumbs .deactive span{
		color: #a9abb5;
		cursor: default;
	}
	.m-portlet-bet-report table{
		text-align: center;
	}
	.m-portlet-bet-report table tbody .sms,
	.m-portlet-bet-report table tbody .code{
	    font-weight: 400;
	    color: #5867DE;
	    cursor: pointer;
	    float: left;
	    margin-left: 10px;
	}
	.m-portlet-bet-report table tfoot,
	.m-portlet-bet-report table thead{
		background: #f4f3f8;
		text-align: center;
	}
	.m-portlet-bet-report .table thead tr:first-child th{
		border-bottom: 1px solid #e9ebf3;
	}
	/*.m-portlet-bet-report .table tfoot td,*/
	.m-portlet-bet-report .table thead th{
    	border-left: 1px solid #e9ebf3;
    	font-weight: 600;
	}
	.m-portlet-bet-report .table tfoot td{
    	font-weight: 600;
	}
	/*.m-portlet-bet-report table tfoot td:last-child,*/
	/*.m-portlet-bet-report table thead th:last-child{
		border-bottom:  0px solid #ffffff
	}*/
	.m-portlet-bet-report .table tfoot td:first-child,
	.m-portlet-bet-report .table thead th:first-child{
		border-left:  0px solid #ffffff
	}
	.m-portlet-bet-report .table tbody tr.even{
		background-color: #f9f9f9;
	}
	.m-portlet-bet-report .table th,
	.m-portlet-bet-report .table td {
	    padding: .3rem;
	}
	.m-portlet-bet-report table.dataTable thead .sorting:before, 
	.m-portlet-bet-report table.dataTable thead .sorting:after, 
	.m-portlet-bet-report table.dataTable thead .sorting_asc:before, 
	.m-portlet-bet-report table.dataTable thead .sorting_asc:after, 
	.m-portlet-bet-report table.dataTable thead .sorting_desc:before, 
	.m-portlet-bet-report table.dataTable thead .sorting_desc:after, 
	.m-portlet-bet-report table.dataTable thead .sorting_asc_disabled:before, 
	.m-portlet-bet-report table.dataTable thead .sorting_asc_disabled:after, 
	.m-portlet-bet-report table.dataTable thead .sorting_desc_disabled:before, 
	.m-portlet-bet-report table.dataTable thead .sorting_desc_disabled:after{
		bottom: 0.4em;
	}
	@media (min-width: 1700px){
		.m-portlet-bet-report .col-xxl-6 {
			max-width: 50%;
			flex: 0 0 50%;
		}
		.m-portlet-bet-report .col-xxl-3{
			max-width: 25%;
			flex: 0 0 25%;
		}
	}
	.remove{
		text-decoration: line-through;
	}
</style>